import React, { Component } from 'react';
import { ButtonToolbar, Button, Form, FormGroup, FormControl } from 'react-bootstrap';
import Select from "react-select";
import { SetOfDayTypesCommand } from '../commands/SetOfDayTypesCommand';
import { HandleMessage } from '../../HandleMessage';
import { LoadingSpinner } from '../../LoadingSpinner';
import { TableButton } from '../../TableButton';

export class PassingIntervalsDataIdentifier extends Component {
    constructor(props) {
        super(props);
        let configuration = {
            componentName: "INTERVALOS MÉDIOS",
            timeThreshold: 9,
            timeInterval: 5,
            leftDayGroups: [],
            rightDayGroups: [],
            availableDayTypes: [],
            intervals: []
        };

        try {
            const parsedConfig = JSON.parse(props.configuration);
            if (parsedConfig) {
                
                if (parsedConfig.dayGroups && Array.isArray(parsedConfig.dayGroups)) {
                    if (parsedConfig.dayGroups.length > 0) {
                        let firstDayType = parsedConfig.dayGroups[0].setOfDayTypes;
                        configuration.leftDayGroups.push({ setOfDayTypes: firstDayType, epochs: [] });

                        parsedConfig.dayGroups.forEach((dayGroup) => {
                            if (dayGroup.setOfDayTypes === firstDayType) {
                                configuration.leftDayGroups[0].epochs.push(dayGroup.descriptionPt);
                            }
                            else {
                                configuration.rightDayGroups.push({ setOfDayTypes: dayGroup.setOfDayTypes, descriptionPt: dayGroup.descriptionPt || "" });
                            }
                        });
                    }
                }
                configuration = Object.assign({}, configuration, parsedConfig);
            }
        } catch (error) {
            console.error('Error parsing configuration:', error);
        }

        if (!configuration.leftDayGroups || configuration.leftDayGroups.length === 0) {
            configuration.leftDayGroups = [{ setOfDayTypes: null, epochs: [""] }];
        }

        this.state = {
            table: { data: [], loading: true },
            message: { show: false, title: undefined, message: undefined, style: undefined, icon: undefined },
            form: configuration,
            actions: { isLoading: true }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            this.setState({
                table: { data: [], loading: true },
                actions: { isLoading: true }
            });
        }

        const setOfDayTypesCommand = new SetOfDayTypesCommand();
        setOfDayTypesCommand.list(
            (result) => {
                this.setState(state => {
                    let updatedForm = Object.assign({}, state.form);
                    updatedForm.availableDayTypes = result.map(dayType => ({
                        id: dayType.id,
                        name: dayType.name
                    }));

                    return {
                        table: { data: result },
                        actions: { isLoading: false },
                        form: updatedForm
                    };
                });
            },
            (error) => {
                this.setState({
                    message: { show: true, message: error, style: "danger", title: "Erro", icon: "remove" }
                });
            }
        );
    }

    handleFormFieldChange(field) {
        return (e) => {
            const value = e.target.type === "number" ? Number(e.target.value) : e.target.value;
            const updatedForm = this.state.form;
            updatedForm[field] = value;
            this.setState({ form: updatedForm });
        };
    }

    onChangeValue(selectedData, target) {
        this.setState(state => {
            let updatedForm = Object.assign({}, state.form);
            updatedForm[target] = selectedData ? selectedData.value : null;
            return { form: updatedForm };
        });
    }

    getLeftSelectedDayTypeIds() {
        const { leftDayGroups = [] } = this.state.form;
        const ids = new Set();

        leftDayGroups.forEach((g, i) => {
            ids.add(Number(g.setOfDayTypes));
        });

        return ids;
    }

    getAllSelectedDayTypeIds(excludeSide = null, excludeIndex = null) {
        const { leftDayGroups = [], rightDayGroups = [] } = this.state.form;
        const ids = new Set();

        leftDayGroups.forEach((g, i) => {
            if (!(excludeSide === 'left' && excludeIndex === i) && g.setOfDayTypes != null) ids.add(Number(g.setOfDayTypes));
        });
        rightDayGroups.forEach((g, i) => {
            if (!(excludeSide === 'right' && excludeIndex === i) && g.setOfDayTypes != null) ids.add(Number(g.setOfDayTypes));
        });

        return ids;
    }

    getSelectOptionsFor(side, index) {
        const { form } = this.state;
        const allOptions = (form.availableDayTypes || []).map(dt => ({ value: dt.id, label: dt.name }));

        if (side === "left") {
            const used = this.getAllSelectedDayTypeIds(side, index);
            return allOptions.filter(o => !used.has(Number(o.value)));
        }
        else {
            const used = this.getLeftSelectedDayTypeIds();
            return allOptions.filter(o => !used.has(Number(o.value)));
        }
    }

    handleLeftGroupChange = (index, field, value) => {
        const newForm = Object.assign({}, this.state.form);
        newForm.leftDayGroups = (newForm.leftDayGroups || []).slice();
        newForm.leftDayGroups[index] = Object.assign({}, newForm.leftDayGroups[index], { [field]: value });
        this.setState({ form: newForm });
    };

    addEpoch = (groupIndex) => {
        const newForm = Object.assign({}, this.state.form);
        newForm.leftDayGroups = (newForm.leftDayGroups || []).slice();
        const epochs = (newForm.leftDayGroups[groupIndex].epochs || []).slice();
        epochs.push("");
        newForm.leftDayGroups[groupIndex] = Object.assign({}, newForm.leftDayGroups[groupIndex], { epochs });
        this.setState({ form: newForm });
    };

    removeEpoch = (groupIndex, epochIndex) => {
        const newForm = Object.assign({}, this.state.form);
        newForm.leftDayGroups = (newForm.leftDayGroups || []).slice();
        const epochs = (newForm.leftDayGroups[groupIndex].epochs || []).slice();
        epochs.splice(epochIndex, 1);
        newForm.leftDayGroups[groupIndex] = Object.assign({}, newForm.leftDayGroups[groupIndex], { epochs });
        this.setState({ form: newForm });
    };

    handleEpochChange = (groupIndex, epochIndex, value) => {
        const newForm = Object.assign({}, this.state.form);
        newForm.leftDayGroups = (newForm.leftDayGroups || []).slice();
        const epochs = (newForm.leftDayGroups[groupIndex].epochs || []).slice();
        epochs[epochIndex] = value;
        newForm.leftDayGroups[groupIndex] = Object.assign({}, newForm.leftDayGroups[groupIndex], { epochs });
        this.setState({ form: newForm });
    };

    addRightGroup = () => {
        const newForm = Object.assign({}, this.state.form);
        newForm.rightDayGroups = (newForm.rightDayGroups || []).slice();
        newForm.rightDayGroups.push({ setOfDayTypes: null, descriptionPt: "" });
        this.setState({ form: newForm });
    };

    removeRightGroup = (index) => {
        const newForm = Object.assign({}, this.state.form);
        newForm.rightDayGroups = (newForm.rightDayGroups || []).slice();
        newForm.rightDayGroups.splice(index, 1);
        this.setState({ form: newForm });
    };

    handleRightGroupChange = (index, field, value) => {
        const newForm = Object.assign({}, this.state.form);
        newForm.rightDayGroups = (newForm.rightDayGroups || []).slice();
        newForm.rightDayGroups[index] = Object.assign({}, newForm.rightDayGroups[index], { [field]: value });
        this.setState({ form: newForm });
    };

    handleDragStart = (e, side, index) => {
        e.dataTransfer.setData("drag", `${side}:${index}`);
    };

    handleDragOver = (e) => {
        e.preventDefault();
    };

    handleDrop = (e, side, newIndex) => {
        e.preventDefault();
        const data = e.dataTransfer.getData("drag");
        if (!data) return;
        const [oldSide, oldIndexStr] = data.split(':');
        const oldIndex = Number(oldIndexStr);
        if (oldSide !== side) return;
        if (oldIndex === newIndex) return;

        const newForm = { ...this.state.form };
        const listKey = side === 'left' ? 'leftDayGroups' : 'rightDayGroups';
        const list = (newForm[listKey] || []).slice();
        const dragged = list.splice(oldIndex, 1)[0];
        list.splice(newIndex, 0, dragged);
        newForm[listKey] = list;
        this.setState({ form: newForm });
    };

    parseTimeToMinutes(timeStr) {
        if (!timeStr) return 0;
        const parts = timeStr.split(':').map(n => Number(n));
        return (parts[0] || 0) * 60 + (parts[1] || 0);
    }

    minutesToTime(mins) {
        const normalized = Math.max(0, Math.min(24 * 60, Math.round(mins)));
        const h = Math.floor(normalized / 60);
        const m = normalized % 60;
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
    }

    addInterval = () => {
        const newForm = Object.assign({}, this.state.form);
        const intervals = newForm.intervals ? newForm.intervals.slice() : [];

        if (intervals.length === 0) {
            // Default First Interval
            intervals.push({ begin: "07:00", end: "09:00" });
        } else {
            const last = intervals[intervals.length - 1];
            const lastEnd = last.end || last.begin || "07:00";
            const newBegin = lastEnd;
            // Default Interval Duration is 2 hours
            const newEnd = this.minutesToTime((this.parseTimeToMinutes(newBegin) + 120) % 1440);
            intervals.push({ begin: newBegin, end: newEnd });
        }

        newForm.intervals = intervals;
        this.setState({ form: newForm });
    };

    removeInterval = (index) => {
        const newForm = Object.assign({}, this.state.form);
        const intervals = newForm.intervals.slice();
        intervals.splice(index, 1);
        if (index > 0 && index < intervals.length) {
            intervals[index].begin = intervals[index - 1].end;
        }
        newForm.intervals = intervals;
        this.setState({ form: newForm });
    };

    isValidPartialTime = (value) => {
        return /^([0-2]?\d?(:?[0-5]?\d?)?)?$/.test(value);
    };

    isValidFullTime = (value) => {
        return /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);
    };

    timeToMinutes = (t) => {
        const [h, m] = t.split(':').map(Number);
        return h * 60 + m;
    };

    assureTimeContiguity(intervals, index, newEndValue) {
        // TODO: Some errors with post midnight hours
        let i = index + 1;

        while (i < intervals.length) {
            const curr = intervals[i];

            const updated = Object.assign({}, curr, { begin: newEndValue });

            const begin = this.timeToMinutes(updated.begin);
            const end = this.timeToMinutes(updated.end);

            if (begin >= end) {
                intervals.splice(i, 1);
                continue;
            }

            if (begin < end) {
                intervals[i] = updated;
                break;
            }

            intervals[i] = Object.assign({}, updated, { end: newEndValue });

            i++;
        }

        return intervals;
    }

    handleIntervalChange = (index, field, value) => {
        if (!this.isValidPartialTime(value)) {
            return;
        }

        const newForm = Object.assign({}, this.state.form);
        const intervals = newForm.intervals.slice();

        const normalized = value;

        intervals[index] = Object.assign({}, intervals[index], { [field]: normalized });

        // Only updates if it is already a complete time
        if (this.isValidFullTime(normalized)) {
            // assure contiguity
            if (field === 'end') {
                this.assureTimeContiguity(intervals, index, normalized);
            }
        }

        newForm.intervals = intervals;
        this.setState({ form: newForm });
    };

    renderIntervals() {
        const { form } = this.state;
        const intervals = form.intervals || [];

        return (
            <div className="intervals-container">
                <label>Intervalos de Tempo</label>
                <table className="table">
                    <thead>
                        <tr>
                            <th style={{ width: '45.6%' }}>Início</th>
                            <th style={{ width: '45.6%' }}>Fim</th>
                            <th style={{ width: '8.8%' }} className="col-actions"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {intervals.map((intv, idx) => (
                            <tr key={idx}>
                                <td>
                                    <FormControl
                                        type="text"
                                        pattern="^([01]\d|2[0-3]):([0-5]\d)$"
                                        value={intv.begin}
                                        onChange={e => this.handleIntervalChange(idx, 'begin', e.target.value)}
                                        disabled={idx > 0}
                                    />
                                </td>
                                <td>
                                    <FormControl
                                        type="text"
                                        pattern="^([01]\d|2[0-3]):([0-5]\d)$"
                                        value={intv.end}
                                        onChange={e => this.handleIntervalChange(idx, 'end', e.target.value)}
                                    />
                                </td>
                                <td className="col-actions" style={{ textAlign: 'center' }}>
                                    <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.removeInterval(idx)} />
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan="2"></td>
                            <td style={{ textAlign: 'center' }}>
                                <TableButton icon="icon-plus" title="Adicionar" onClick={() => this.addInterval()} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderDayGroups() {
        const { form } = this.state;
        const { leftDayGroups = [], rightDayGroups = [], availableDayTypes = [] } = form;

        if (!availableDayTypes || availableDayTypes.length === 0) {
            return <LoadingSpinner />;
        }

        return (
            <div className="day-groups-container mt-3">
                <div style={{ display: 'flex', gap: '24px' }}>
                    <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <strong>Grupo de tipo de dia principal</strong>
                        </div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Tipo de Dia</th>
                                    <th>Épocas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {leftDayGroups.map((group, index) => {
                                    const options = this.getSelectOptionsFor('left', index);
                                    const selected = options.find(o => Number(o.value) === Number(group.setOfDayTypes)) ||
                                        (group.setOfDayTypes != null ? { value: group.setOfDayTypes, label: (availableDayTypes.find(d => d.id === group.setOfDayTypes) || {}).name } : null);

                                    return (
                                        <tr key={index}>
                                            <td style={{ width: '50%' }}>
                                                <Select
                                                    options={options}
                                                    value={selected}
                                                    onChange={selected => this.handleLeftGroupChange(index, 'setOfDayTypes', selected ? selected.value : null)} />
                                            </td>
                                            <td>
                                                {(group.epochs || []).map((ep, ei) => (
                                                    <div key={ei} style={{ display: 'flex', gap: '8px', marginBottom: '6px' }}>
                                                        <FormControl
                                                            type="text"
                                                            value={ep}
                                                            onChange={e => this.handleEpochChange(index, ei, e.target.value)}
                                                            placeholder="Época"
                                                        />
                                                        <TableButton icon="icon-trash" title="Eliminar Época" onClick={() => this.removeEpoch(index, ei)} />
                                                    </div>
                                                ))}
                                                <div>
                                                    <TableButton icon="icon-plus" title="Adicionar Época" onClick={() => this.addEpoch(index)} />
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <strong>Grupos de tipo de dia secundários</strong>
                        </div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Tipo de Dia</th>
                                    <th>Descrição</th>
                                    <th className="col-actions"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rightDayGroups.map((group, index) => {
                                    const options = this.getSelectOptionsFor('right', index);
                                    const selected = options.find(o => Number(o.value) === Number(group.setOfDayTypes)) ||
                                        (group.setOfDayTypes != null ? { value: group.setOfDayTypes, label: (availableDayTypes.find(d => d.id === group.setOfDayTypes) || {}).name } : null);

                                    return (
                                        <tr key={index} draggable onDragStart={(e) => this.handleDragStart(e, 'right', index)} onDragOver={this.handleDragOver} onDrop={(e) => this.handleDrop(e, 'right', index)}>
                                            <td style={{ width: '35%' }}>
                                                <Select
                                                    options={options}
                                                    value={selected}
                                                    onChange={selected => this.handleRightGroupChange(index, 'setOfDayTypes', selected ? selected.value : null)} />
                                            </td>
                                            <td>
                                                <FormControl
                                                    type="text"
                                                    value={group.descriptionPt}
                                                    onChange={e => this.handleRightGroupChange(index, 'descriptionPt', e.target.value)}
                                                    placeholder="Descrição"
                                                />
                                            </td>
                                            <td className="col-actions">
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.removeRightGroup(index)} />
                                            </td>
                                        </tr>
                                    );
                                })}
                                {rightDayGroups.length === 0 && (
                                    <tr>
                                        <td colSpan="3" className="no-groups-text">Nenhum grupo</td>
                                    </tr>
                                )}
                                <tr>
                                    <td>
                                        <TableButton icon="icon-plus" title="Adicionar Época" onClick={() => this.addRightGroup()} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    handleComponentNameChange = (value) => {
        let newForm = Object.assign({}, this.state.form);
        newForm.componentName = value;

        this.setState({ form: newForm });
    };

    renderComponentName() {
        const { form } = this.state;

        return (
            <div className="component-name-container">
                <label>Nome do Componente</label>
                <FormControl
                    type="text"
                    placeholder="INTERVALOS MÉDIOS"
                    value={form.componentName}
                    onChange={(e) => this.handleComponentNameChange(e.target.value)}
                />
            </div>
        );
    }

    handleTimeThresholdChange = (value) => {
        let newForm = Object.assign({}, this.state.form);
        newForm.timeThreshold = Number(value);
        if (newForm.timeThreshold > 0) this.setState({ form: newForm });
    };

    handleTimeIntervalChange = (value) => {
        let newForm = Object.assign({}, this.state.form);
        newForm.timeInterval = Number(value);
        if (newForm.timeInterval > 0) this.setState({ form: newForm });
    };

    renderTimeParams() {
        const { form } = this.state;

        return (
            <div className="time-params-container mt-3">
                <div className="threshold">
                    <label style={{ marginBottom: '0px' }}>Mostrar tempo exato até (minutos)</label>
                    <br></br>
                    <labe class="muted-text">Até este valor, o tempo de espera é mostrado com precisão (ex: 9 min)</labe>
                    <FormControl
                        type="number"
                        placeholder="9"
                        value={form.timeThreshold}
                        onChange={(e) => this.handleTimeThresholdChange(e.target.value)}
                    />
                </div>
                <div className="threshold">
                    <label style={{ marginBottom: '0px' }}>Tamanho dos intervalos (minutos)</label>
                    <br></br>
                    <labe class="muted-text">Define os intervalos usados acima desse valor (ex: 10–15, 15–20)</labe>
                    <FormControl
                        type="number"
                        placeholder="5"
                        value={form.timeInterval}
                        onChange={(e) => this.handleTimeIntervalChange(e.target.value)}
                    />
                </div>
            </div>
        );
    }

    onFinishSelectData = () => {
        const { form } = this.state;

        const left = (form.leftDayGroups || []).flatMap(g => {
            const id = g.setOfDayTypes;
            const epochs = (g.epochs || []).filter(e => e != null && e !== "");
            if (!epochs.length) {
                return [{ setOfDayTypes: id, descriptionPt: "" }];
            }
            return epochs.map(ep => ({ setOfDayTypes: id, descriptionPt: ep }));
        });

        const right = (form.rightDayGroups || []).map(g => ({
            setOfDayTypes: g.setOfDayTypes,
            descriptionPt: g.descriptionPt || ""
        }));

        const finalDayGroups = [...left, ...right];

        const data = finalDayGroups.map(group => Number(group.setOfDayTypes));

        const configuration = {
            componentName: form.componentName,
            timeThreshold: form.timeThreshold,
            timeInterval: form.timeInterval,
            dayGroups: finalDayGroups,
            availableDayTypes: form.availableDayTypes,
            intervals: form.intervals
        };

        this.props.onSelectData(data);
        this.props.onConfigureData(JSON.stringify(configuration), true);

        this.setState({
            selectedData: null,
            form: {
                leftDayGroups: [{ setOfDayTypes: null, epochs: [""] }],
                rightDayGroups: [],
                availableDayTypes: [],
                intervals: []
            },
            styles: {},
        });
    }

    render() {
        const { message, actions } = this.state;
        if (actions.isLoading) return <LoadingSpinner />;

        return (
            <div>
                <Form>
                    <FormGroup>
                        {this.renderComponentName()}
                        {this.renderTimeParams()}
                        {this.renderDayGroups()}
                        {this.renderIntervals()}
                    </FormGroup>
                </Form>

                <ButtonToolbar className="mt-4">
                    <Button bsStyle="default" onClick={this.onFinishSelectData}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.setState({ message: { show: false } })}
                />
            </div>
        );
    }
}